<kodit-table [tableConfig]="tableConfig" [items]="korisniciTable">
</kodit-table>
